import type { CourseModule } from "@/core/types";
import { lektionEntwicklertools } from "./lektion-01-entwicklertools";
import { lektionSteuerelemente } from "./lektion-02-steuerelemente";
import { lektionFormularSchuetzen } from "./lektion-03-schuetzen";

export const modulFormulare: CourseModule = {
  id: "formulare",
  title: "Formulare",
  summary:
    "Ausfüllbare Formulare mit Inhaltssteuerelementen bauen – mit Feldtypen, die " +
    "zur Eingabe passen, und Schutz gegen versehentliche Änderungen.",
  level: "Aufbau",
  lessons: [lektionEntwicklertools, lektionSteuerelemente, lektionFormularSchuetzen],
};
